/**
 * MIRA Label Component
 * Wraps Shadcn Label with MIRA design system styles
 */

import React from 'react';
import { Label as ShadcnLabel } from '@/components/ui/label';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/label.module.css';

export const Label = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnLabel
        ref={ref}
        className={cn(styles.miraLabel, className)}
        {...props}
      />
    );
  }
);

Label.displayName = 'MiraLabel';
